<template>
  <div>
    <!-- <img src="/images/public/about_us_banner.gif" class="banner-style w-100"/> -->
    <div class="d-flex base-wrap">
      <div class="mt-5 w-20 mr-5">
        <el-menu :default-active = activeIndex style="height: 200px" background-color="#3d3d3d" text-color="#fff" active-text-color="#ffd04b">
          <div v-for="item in menuItem" :key="item.index">
            <el-menu-item :index="item.index" @click="$router.push(item.routeTo)">
              <i :class="item.icon"></i>
              <span slot="title">{{item.title}}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </div>
      <div class="mt-5 ml-3 w-70">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  // import AdBanner from '../IndexComps/AdBanner'

  export default {
    name: 'AboutUs',
    data() {
      return {
        activeIndex:'0',                                                     //激活的activeIndex
        menuItem:[                                                           //菜单栏条目
          {index:'0',title:'关于我们',routeTo:'/about_us',icon:'el-icon-info'},
          {index:'1',title:'团队介绍',routeTo:'/about_us/team_detail',icon:'el-icon-document'},
          {index:'2',title:'诚征英才',routeTo:'/about_us/join_us',icon:'el-icon-view'},
          {index:'3',title:'联系我们',routeTo:'/about_us/contact_us',icon:'el-icon-phone'},
        ],
      }
    },
    watch:{
      $route : {
       handler(val) {
         switch (val.path) {
           case '/about_us':  this.activeIndex = '0'; break;
           case '/about_us/team_detail':  this.activeIndex = '1'; break;
           case '/about_us/join_us':  this.activeIndex = '2'; break;
           case '/about_us/contact_us':  this.activeIndex = '3'; break;
         }
       },
        immediate:true,
      }
    }
  }
</script>
<style scoped lang="scss">
  .banner-style{
    min-width: 1200px;
  }
</style>
